import React from "react";

// Style
import {
  ButtonWrap,
  EmptyContent,
  EmptyState,
  EmpytText,
} from "../../style/Empty";

// Images
import empty from "../../images/ic_empty.svg";

// Component
import Button from "../button";

const index = ({ title, text, button1, onClick, style = {} }) => {
  return (
    <EmptyState style={style}>
      <EmptyContent>
        <img src={empty} alt={empty} />
        <EmpytText>
          <h2>{title}</h2>
          <p>{text}</p>
        </EmpytText>
        <ButtonWrap>
          {button1 && <Button title={button1} color="primary" onClick={onClick} />}
        </ButtonWrap>
      </EmptyContent>
    </EmptyState>
  );
};

export default index;
